import React, { useState } from "react";
import { RiLiveFill } from "react-icons/ri";
import livenessImage from "../../../../assets/images/LivenessImage.png";
import WebcamModal from "./WebcamVideoModal";

function VideoRecorder({ onSubmitVerification, setVideo }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [recordedVideo, setRecordedVideo] = useState(null);

    const handleVideoRecorded = (videoUrl) => {
        setRecordedVideo(videoUrl);
        setVideo(videoUrl);
    };

    return (
        <div className="tw-flex tw-flex-col tw-mt-[55px] tw-w-[80%]  tw-items-center tw-h-screen">
            <div className="tw-w-full tw-flex tw-flex-col  tw-pb-5">
                <h1 className="tw-text-2xl tw-font-bold tw-text-dark_text tw-mb-6">Record Your Face Scan</h1>

                {!recordedVideo && (
                    <div className="tw-bg-white tw-flex tw-justify-center tw-border-1 tw-border-dashed tw-border-primary tw-rounded-lg tw-overflow-hidden tw-relative">
                        <div className="tw-p-5">
                            <div className="tw-w-64 tw-h-64 tw-rounded-full tw-border-4 tw-border-primary-300 tw-border-dashed">
                                <img src={livenessImage} alt="Camera preview area" className="tw-w-full tw-h-full tw-rounded-full tw-object-cover" />
                            </div>
                        </div>
                    </div>
                )}

                {recordedVideo && (
                    <div className="tw-mt-4">
                        <h3 className="tw-text-lg tw-font-semibold">Recorded Video:</h3>
                        <video src={recordedVideo} controls className="tw-w-full tw-h-96 tw-rounded-lg tw-shadow-lg"></video>
                    </div>
                )}

                <div className="tw-text-start tw-mb-6">
                    <a href="#" className="tw-text-primary tw-text-sm tw-hover:underline">
                        Help Section: What to do if the camera isn't working or if you prefer to upload an existing photo
                    </a>
                </div>

                <div className="tw-mb-8">
                    <h2 className="tw-text-lg tw-font-medium tw-text-black tw-mb-3">Instructions:</h2>
                    <ul className="tw-space-y-2 tw-text-black tw-leading-4 tw-mb-6">
                        <li className="tw-flex tw-items-center">
                            <span className="tw-w-2 tw-h-2 tw-bg-black tw-rounded-full tw-mr-3"></span>
                            Position your face within the oval guide
                        </li>
                        <li className="tw-flex tw-items-center">
                            <span className="tw-w-2 tw-h-2 tw-bg-black tw-rounded-full tw-mr-3"></span>
                            When ready, tap 'Start Recording'
                        </li>
                        <li className="tw-flex tw-items-center">
                            <span className="tw-w-2 tw-h-2 tw-bg-black tw-rounded-full tw-mr-3"></span>
                            Slowly turn your head from left to right
                        </li>
                        <li className="tw-flex tw-items-center">
                            <span className="tw-w-2 tw-h-2 tw-bg-black tw-rounded-full tw-mr-3"></span>
                            Recording will stop automatically after 5 seconds
                        </li>
                    </ul>
                </div>

                <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-4 tw-justify-center">
                    {!recordedVideo && (
                        <button
                            onClick={() => setIsModalOpen(true)}
                            className="tw-px-14 tw-py-3 tw-bg-primary tw-text-white tw-rounded-md hover:tw-bg-primary-hover tw-transition-colors tw-font-semibold"
                        >
                            Start
                        </button>
                    )}
                    {recordedVideo && (
                        <>
                            <button
                                onClick={() => setRecordedVideo(null)}
                                className="tw-px-14 tw-py-3 tw-bg-white hover:tw-bg-primary hover:tw-border-primary hover:tw-text-white tw-border tw-border-black tw-text-black tw-rounded-md tw-transition-colors tw-font-semibold"
                            >
                                Retake
                            </button>
                            <button
                                onClick={onSubmitVerification}
                                className="tw-px-14 tw-py-3 tw-bg-primary tw-text-white tw-rounded-md hover:tw-bg-primary-hover tw-transition-colors tw-font-semibold"
                            >
                                Submit Verification
                            </button>
                        </>
                    )}
                </div>
            </div>

            {/* Webcam Modal */}
            <WebcamModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onVideoRecorded={handleVideoRecorded} />
        </div>
    );
}

export default VideoRecorder;
